import React from "react";
import { A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import VideoModal from "../ModalVideo/VideoModal";
import 'swiper/css';
import headerVideo from '../../images/header.mp4'
const HeroSlider = () => {
    const reelUrl = "https://www.facebook.com/reel/3038022969726730";
  
    return (
        <section className="wpo-hero-slider wpo-hero-slider-s1" >
            <Swiper
                // install Swiper modules
                modules={[A11y]}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                speed={1000}
                parallax={true}
            >
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image">
                        <video
                            className="hero-bg-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source src={headerVideo} type="video/mp4" />
                        </video>
                        <div className="container-fluid">
                            <div className="slide-content">
                                <div className="slide-title">
                                    <h2 >Leaders Diamant Alu <br />
                                    L’excellence de l’aluminium</h2>
                                </div>
                                <div className="slide-text">
                                    <p >
                                    Leaders Diamant Alu vous accompagne dans la conception et la réalisation de solutions en aluminium sur mesure . De la fabrication à l’installation, nous mettons notre expertise au service de vos projets.
                                    </p>
                                </div>
                                <div className="clearfix"></div>
                                <div  className="slide-btns">
                                    <ul>
                                        <li className="video-holder">
                                            <VideoModal externalUrl={reelUrl} />
                                        </li>
                                        <li className="video-text">
                                            <a href={reelUrl} target="_blank" rel="noopener noreferrer">Voir notre vidéo</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image">
                        <video
                            className="hero-bg-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source src={headerVideo} type="video/mp4" />
                        </video>
                        <div className="container-fluid">
                            <div className="slide-content">
                            <div className="slide-title">
                                    <h2>Pour l'industrie de l'aluminium, rien n'est impossible.</h2>
                                </div>  
                                <div className="slide-text">
                                    <p>Spécialistes de la production et de la transformation d'aluminium. Profils extrudés, tôles et pièces sur mesure pour vos projets industriels.</p>
                                </div>
                                <div className="clearfix"></div>
                                <div  className="slide-btns">
                                    <ul>
                                        <li className="video-holder">
                                            <VideoModal externalUrl={reelUrl} />
                                        </li>
                                        <li className="video-text">
                                            <a href={reelUrl} target="_blank" rel="noopener noreferrer">Voir notre vidéo</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="slide-inner slide-bg-image">
                        <video
                            className="hero-bg-video"
                            autoPlay
                            muted
                            loop
                            playsInline
                        >
                            <source src={headerVideo} type="video/mp4" />
                        </video>
                        <div className="container-fluid">
                            <div className="slide-content">
                            <div className="slide-title">
                                    <h2>Pour l'industrie de l'aluminium, rien n'est impossible.</h2>
                                </div>
                                <div className="slide-text">
                                    <p>Spécialistes de la production et de la transformation d'aluminium. Profils extrudés, tôles et pièces sur mesure pour vos projets industriels.</p>
                                </div>
                                <div className="clearfix"></div>
                                <div className="slide-btns">
                                    <ul>    
                                        <li className="video-holder">
                                            <VideoModal externalUrl={reelUrl} />
                                        </li>
                                        <li className="video-text">
                                            <a href={reelUrl} target="_blank" rel="noopener noreferrer">Voir notre vidéo</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </SwiperSlide>

                ...
            </Swiper>
        </section>
    );
};

export default HeroSlider;






